// Ticket personalisation (concept G) – checkout: "Auf mich ausstellen" fills one ticket's holder fields from the
// billing name (template-parts/checkout/holders.php). The fields themselves are plain WC checkout inputs
// (kt_holders[{cart key}][{n}][first|last]) validated server-side; holder edits in the account use forms.js.
import { qs, on } from './dom.js';

export function initHolders() {
  const box = qs('[data-holders]');
  if (!box) return;
  on(box, 'click', '[data-holder-self]', (e, btn) => {
    e.preventDefault();
    const row = btn.closest('[data-holder-row]');
    const first = qs('#billing_first_name');
    const last = qs('#billing_last_name');
    if (!row || !first || !last) return;
    if (!first.value.trim() && !last.value.trim()) { first.focus(); return; }
    qs('[data-holder-first]', row).value = first.value.trim();
    qs('[data-holder-last]', row).value = last.value.trim();
  });
}
